
define('text!templates/parts/chart/bar-chart.html',[],function () { return '<div class="bar-chart">\n    <div class="chart-canvas"><div><canvas></canvas></div></div>\n</div>\n';});

